import React from "react";
import { get } from "lodash";
import PropTypes from "prop-types";
import { LoadMoreStoriesBase, Link } from "@quintype/components";
import { WebEngage, GA } from "../../../integrations";
import { LoadMoreButton } from "../../atoms/read-more-link";
import SixStoryOneBigStory from "../../rows/six-story-one-big-story";
import { FIELDS_FOR_LISTING_PAGE, PAGE_TYPE } from "../../../constants";
import styles from "./styles.m.css";
import { fetchForyouTopics, fetchLatestStories, postForyouTopics } from "../../../api";
import Icon from "../../atoms/icon";
import NineteenStories from "../../rows/nineteen-stories";
import Cookies from "universal-cookie";
import SkeletonLoading from "../../atoms/skeleton-screen-loading";
import { checkQueryString } from "../../utils/utils";
import { VikatanCollectionResponsive } from "../../rows/ad-free";

const cookies = new Cookies();
const thinmint = cookies.get("thinmint") || cookies.get("vikatanthinmint");
const vuid = cookies.get("vuid") || "";

const StoryList = ({ stories }) =>
  stories.length > 0 ? (
    <React.Fragment>
      <NineteenStories stories={stories} />
      <SixStoryOneBigStory items={stories} />
    </React.Fragment>
  ) : (
    <h3 className={styles["no-results"]}>No results found</h3>
  );

StoryList.propTypes = {
  stories: PropTypes.arrayOf(SixStoryOneBigStory.propTypes.story)
};

const StoryListBase = ({ stories, loading, onLoadMore, noMoreStories }) => {
  return (
    <React.Fragment>
      <StoryList stories={stories} />
      {!noMoreStories &&
        stories.length >= 19 && (
          <div className={styles["load-more-wrap"]}>
            <LoadMoreButton text={loading ? "LOADING..." : " மேலும் படிக்க"} disabled={loading} onClick={onLoadMore} />
          </div>
        )}
    </React.Fragment>
  );
};

export { StoryListBase };

StoryListBase.propTypes = {
  stories: PropTypes.arrayOf(SixStoryOneBigStory.propTypes.story),
  loading: PropTypes.bool,
  onLoadMore: PropTypes.func,
  noMoreStories: PropTypes.bool
};

const staticTopics = [
  {
    name: "அரசியல்",
    slug: "politics-all",
    isSelected: "0",
    "image-url": "https://media.vikatan.com/vikatan/2019-12/488947e4-dede-4216-99fb-2132c0bd5d20/politics.png",
    color: "#fd9568",
    tags: "politics,government,government-and-politics"
  },
  {
    name: "க்ரைம்",
    slug: "crime-news",
    isSelected: "0",
    "image-url": "https://media.vikatan.com/vikatan/2019-12/15dea9b6-cdcb-4c29-9dcd-b38848b63e2c/crime.png",
    color: "#e9ad18",
    tags:
      "crime,crime-report,cyber-crime,digital-crimes,murder, harassment,sexual-harassment,sexual-abuse,sexually-abused"
  },
  {
    name: "சினிமா  ",
    slug: "latest-cinema-news",
    isSelected: "0",
    "image-url": "https://media.vikatan.com/vikatan/2019-12/e2e1bce2-18e7-4a5d-9c40-35f6188b04c6/cinema.png",
    color: "#71A55A",
    tags: "cinema,kollywood,bollywood"
  },
  {
    name: "விளையாட்டு",
    slug: "sports-home",
    isSelected: "0",
    "image-url": "https://media.vikatan.com/vikatan/2019-12/a63b50ae-b242-45f2-b22c-7135bd1011b5/sports.png",
    color: "#e9ad18",
    tags: "sport,sports,cricket,foodball,ipl"
  },
  {
    name: "ஆன்மிகம்",
    slug: "spiritual-home",
    isSelected: "0",
    "image-url": "https://media.vikatan.com/vikatan/2019-12/84c924ae-98f9-44d8-8222-51d4e9099a3b/spiritual.png",
    color: "#69584A",
    tags: "spiritual"
  },
  {
    name: "பிசினஸ்",
    slug: "business",
    isSelected: "0",
    "image-url": "https://media.vikatan.com/vikatan/2019-12/c85d610d-0849-46ba-84ac-c02ecb3ff8c9/business.png",
    color: "#F51300",
    tags: "investment,finance,money-saving,business,financial-planning"
  },
  {
    name: "பெண்கள்",
    slug: "women-home",
    isSelected: "0",
    "image-url": "https://media.vikatan.com/vikatan/2019-12/539291c9-b030-4e69-8241-0212b61b4941/digitalmom.png",
    color: "#42ca70",
    tags: "women,husband-wife"
  },
  {
    name: "ஆரோக்கியம்",
    slug: "health",
    isSelected: "0",
    "image-url": "https://media.vikatan.com/vikatan/2019-12/7e58cccd-995b-4ea4-be45-45637dc6f02b/health.png",
    color: "#B3F41F",
    tags: "health,treatment,siddha-medicine"
  },
  {
    name: "மோட்டார்",
    slug: "automobile",
    isSelected: "0",
    "image-url": "https://media.vikatan.com/vikatan/2019-12/df630943-b207-4b9f-b470-ccdb8ee246b7/automobiles.png",
    color: "#8187d5",
    tags: "motor,automobile,car,bike"
  },
  {
    name: "ஹ்யூமர்",
    slug: "humoursatire-entertainment",
    isSelected: "0",
    "image-url": "https://media.vikatan.com/vikatan/2019-12/4c8fed95-f4f9-4e2d-9e94-f3891adfc97f/humor.png",
    color: "#258e9c",
    tags: "humoursatire,humour,memes"
  },
  {
    name: "விவசாயம்",
    slug: "agriculture-all",
    isSelected: "0",
    "image-url": "https://media.vikatan.com/vikatan/2021-07/1c03bacd-409f-4caa-9dbc-9220a0f25822/agriculture.jpg",
    color: "#b988bd",
    tags: ""
  },
  {
    name: "உணவு ",
    slug: "food",
    isSelected: "0",
    "image-url": "https://media.vikatan.com/vikatan/2019-12/c8570724-1d91-4976-94d2-ca7edf07e52f/food.png",
    color: "#d4485d",
    tags: "food,fast-food,briyani"
  }
];

const ForyouPage = ({ data }) => {
  const [topics, setTopics] = React.useState(staticTopics);
  const [tag, setTag] = React.useState(null);
  const [activeBar, setActivebar] = React.useState("loading");
  const [user] = React.useState(""); // use ""
  const [stories, setStories] = React.useState({});

  React.useEffect(() => {
    WebEngage.registerPageView();
    GA.registerPageView(PAGE_TYPE.TOPIC_PAGE, {});

    fetchForyouTopics(vuid, thinmint)
      .then(topic => {
        const top = get(topic, ["data", "items"], []);
        setTopics(top);
        handleTopicData(top);
      })
      .catch(console.error);
  }, []);

  const handleFilter = (slug, index) => {
    const selectTopics =
      topics &&
      topics.length >= 0 &&
      topics.map((item, index) => {
        if (slug === item.slug) item.isSelected = item.isSelected === "0" ? "1" : "0";

        return item;
      });
    setTopics(selectTopics);
  };

  const handleActiveBar = name => {
    setActivebar(name);
  };

  const handleSave = () => {
    setTag(null);

    if (typeof user === "string") {
      isCookieUser(topics);
    }

    postForyouTopics(vuid, thinmint, topics)
      .then(response => {})
      .catch(console.error);
    handleTopicData(topics, true);
  };

  const handleTopicData = (top, action = false) => {
    const tag = top
      .filter(item => item.isSelected === "1" && item)
      .map(i => i.tags)
      .join(",");

    const praams = {};
    praams["tag-slugs"] = `${tag}`;
    fetchLatestStories(0, 19, praams)
      .then(response => {
        const stories = get(response, ["stories"], []);
        const storySchema =
          stories &&
          stories.map(i => {
            const schema = i;
            schema.url = `${i.url}?pfrom=my-news`;
            return schema;
          });
        data.stories = storySchema;
        setStories(data);

        setTag(tag);
        const viewbar = checkQueryString("view");

        if (viewbar === "edit" && action === false) {
          setActivebar("edit");
        } else {
          setActivebar("myfeed");
        }
      })
      .catch(console.error);
  };

  const CollectionSlides =
    topics &&
    topics.length >= 0 &&
    topics.map((item, index) => {
      const checked = item.isSelected === "1";

      const iconView =
        item.slug === "crime-news"
          ? "crime"
          : item.slug === "latest-cinema-news"
            ? "cinema"
            : item.slug === "sports-home"
              ? "sports"
              : item.slug === "spiritual-home"
                ? "spiritual"
                : item.slug === "agriculture-all"
                  ? "environment"
                  : item.slug === "food"
                    ? "food-stylist"
                    : item.slug === "cinema-entertainment"
                      ? "cinema"
                      : item.slug === "motor-technology"
                        ? "automobile"
                        : item.slug;

      return (
        <div
          className={`${styles["box-grid"]} ${item.isSelected === "1" && styles["selected"]}`}
          onClick={() => handleFilter(item.slug, index)}
          key={index}
        >
          <Icon type={iconView} className={styles["topics-icon"]} />

          <div className={styles["topics-name"]}>{item.name}</div>
          <div className={styles["checkbox"]}>
            <input type="checkbox" defaultChecked={checked} />
          </div>
        </div>
      );
    });

  const isCookieUser = topics => {
    if (!global.localStorage) {
      return true;
    }

    global.localStorage.setItem("foryoutopics", JSON.stringify(topics));
  };
  return (
    <div className={`main-page ${styles["base-container"]}`}>
      <div />
      <div>
        <div className={`container`}>
          <h2 className={styles["title"]}>My News</h2>
          <div className={styles["foryou-main"]}>
            <ul className={styles["foryou-header"]}>
              <li
                className={`${activeBar === "myfeed" && styles["active-bar"]}`}
                onClick={() => handleActiveBar("myfeed")}
              >
                My News
              </li>
              <li className={`${activeBar === "edit" && styles["active-bar"]}`} onClick={() => handleActiveBar("edit")}>
                <Icon type="personalise" className={styles["personalise-icon"]} /> Personalise
              </li>
              <li>
                <Link aria-label="Recommended For You" href={`/recommended-for-you`} className={`${styles["link"]}`}>
                  Recommended For You
                </Link>
              </li>
            </ul>
            {activeBar === "edit" || !tag ? (
              <div>
                {activeBar !== "loading" && (
                  <div>
                    <div className={styles["foryou-grid"]}>{CollectionSlides}</div>
                    <div className={styles["button"]}>
                      {topics.length !== 0 && (
                        <button onClick={() => handleSave()} className={styles["active-btn"]}>
                          Save
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div>
                {stories && (
                  <LoadMoreStoriesBase
                    api="/api/v1/stories"
                    template={StoryListBase}
                    numStoriesToLoad={20}
                    data={stories}
                    params={{ "tag-slugs": tag }}
                    fields={FIELDS_FOR_LISTING_PAGE}
                  />
                )}
              </div>
            )}

            {activeBar === "loading" &&
              !tag && (
                <div>
                  <div className={styles["row"]}>
                    <SkeletonLoading />
                    <SkeletonLoading />
                    <SkeletonLoading />
                    <SkeletonLoading />
                  </div>
                  <div className={styles["row"]}>
                    <SkeletonLoading />
                    <SkeletonLoading />
                    <SkeletonLoading />
                    <SkeletonLoading />
                  </div>
                </div>
              )}
          </div>
        </div>
        <div className={styles["tag-ad"]}>
          <VikatanCollectionResponsive
            DesktopAdtype="Vikatan2023_Desktop_SP_BTF_728x90"
            MobileAdtype="Vikatan2023_Mobile_SP_TOP_320x100"
            placement="bundle"
          />
        </div>
      </div>
      <div />
    </div>
  );
};

export { ForyouPage };

ForyouPage.propTypes = {
  data: PropTypes.shape({
    tag: PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string
    }),
    stories: PropTypes.arrayOf(SixStoryOneBigStory.propTypes.story)
  })
};
